module.exports = __webpack_public_path__ + "img/ricelog_pinicon_082.0b453152.png";